
export const endPoints = {
  //AddOnCategory
  addOnCategory: {
    create: "/v1/admin/addoncategory/create",
    getAll: "/v1/admin/addoncategory/get-all",
    update: "/v1/admin/addoncategory/update",
    delete: "/v1/admin/addoncategory/delete",
    dropdown: "/v1/admin/addoncategory/dropdown",
  },
   //Dashboard
  dashboard: {
    getStatistics: "/v1/admin/dashboard/get-statistics",
    search: "/v1/admin/dashboard/search",
  },
  //Auth
  auth: {
    login: "/v1/admin/auth/login",
    refreshToken: "/v1/admin/auth/refresh-token",
  },
  //City
  city: {
    dropdown: "/v1/admin/city/dropdown",
    dropdownByCountry: "/v1/admin/city/dropdown",
    getAll: "/v1/admin/city/get-all",
    getAllByCountry: "/v1/admin/city/get-all-by-country",
    getAllSearch: "/v1/admin/city/get-all-search",
    toggleActivate: "/v1/admin/city/toggle-activate",
    create: "/v1/admin/city",
    update: "/v1/admin/city/update",
    edit: "/v1/admin/city/edit",
    deleteImage: "/v1/admin/city/delete-image",
    delete: "/v1/admin/city",
    getDetails: "/v1/admin/city/get-details",
  },
  //Country
  country: {
    dropdown: "/v1/admin/country/dropdown",
    getAll: "/v1/admin/country/get-all",
    getAllSearch: "/v1/admin/country/get-all-search",
    toggleActivate: "/v1/admin/country/toggle-activate",
    create: "/v1/admin/country",
    update: "/v1/admin/country/update",
    edit: "/v1/admin/country/edit",
    delete: "/v1/admin/country",
    getDetails: "/v1/admin/country/get-details",
  },
  //Category
  category: {
    dropdown: "/v1/admin/category/dropdown",
    getAll: "/v1/admin/category/get-all",
    getAllSearch: "/v1/admin/category/get-all-search",
    toggleActivate: "/v1/admin/category/toggle-activate",
    create: "/v1/admin/category",
    update: "/v1/admin/category/update",
    edit: "/v1/admin/category/edit",
    deleteImage: "/v1/admin/category/delete-image",
    delete: "/v1/admin/category",
    getDetails: "/v1/admin/category/get-details",
  },
  //Banner
  banner: {
    getAll: "/v1/admin/banner/get-all",
    getAllSearch: "/v1/admin/banner/get-all-search",
    create: "/v1/admin/banner",
    update: "/v1/admin/banner/update",
    edit: "/v1/admin/banner/edit",
    deleteImage: "/v1/admin/banner/delete-image",
    delete: "/v1/admin/banner",
    getDetails: "/v1/admin/banner/get-details",
  },
  //User
  user: {
    getProviderDropdown: "/v1/admin/User/get-provider-dropdown",
  },
  //Trip
  trip: {
    getAll: "/v1/admin/Trip/get-all",
    getAllSearch: "/v1/admin/Trip/get-all-search",
    create: "/v1/admin/Trip/create",
    update: "/v1/admin/Trip/update",
    edit: "/v1/admin/Trip/edit",
    deleteImage: "/v1/admin/Trip/delete-image",
    toggleActivate: "/v1/admin/Trip/toggle-activate",
    getDetail: "/v1/admin/Trip/get-detail",
    delete: "/v1/admin/Trip/delete",
    getDropdown: "/v1/admin/Trip/get-dropdown",
    getTripUnavailableDates: "/v1/admin/Trip",
  },
  //Trip Unavailable Date
  tripUnavailableDate: {
    get: "/v1/admin/tripunavailabledate",
    create: "/v1/admin/tripunavailabledate",
    delete: "/v1/admin/tripunavailabledate",
  },
  //Trip Video
  tripVideo: {
    create: "/v1/admin/tripvideo",
    delete: "/v1/admin/tripvideo",
  },
  //Package
  package: {
    getTripPackages: "/v1/admin/package/get-trip-packages",
  },
  //Provider
  provider: {
    getAll: "/v1/admin/Provider/get-all",
    getAllSearch: "/v1/admin/Provider/get-all-search",
    create: "/v1/admin/Provider/create",
    update: "/v1/admin/Provider/update",
    edit: "/v1/admin/Provider/edit",
    toggleActivate: "/v1/admin/Provider/toggle-activate",
    toggleProviderDashboard: "/v1/admin/Provider/toggle-provider-dashboard",
    getDetail: "/v1/admin/Provider/get-detail",
    delete: "/v1/admin/Provider/delete",
    deleteImage: "/v1/admin/Provider/delete-image",
  },
// Customer
customer: {
  dropdown: "/v1/admin/Customer/dropdown",
  getAll: "/v1/admin/Customer/get-all",
  getAllSearch: "/v1/admin/Customer/get-all-search",
  create: "/v1/admin/Customer/create",
  edit: "/v1/admin/Customer/edit",
  getDetail: "/v1/admin/Customer/get-detail",
  update: "/v1/admin/Customer/update",
  deleteImage: "/v1/admin/Customer/delete-image",
  delete: "/v1/admin/Customer/delete",
  toggleActivate: "/v1/admin/Customer/toggle-activate",
},
  // BlockUser
  blockUser: {
    getAll: "/v1/admin/BlockedUser/get-all",
    getAllSearch: "/v1/admin/BlockedUser/get-all-search",
    block: "/v1/admin/BlockedUser/block",
    toggle: "/v1/admin/BlockedUser/toggle",
  },
  // UserActivity
  userActivity: {
    getAll: "/v1/admin/UserActivity/get-all",
    getAllSearch: "/v1/admin/UserActivity/get-all-search",
  },
  // ConnectedUser
  connectedUser: {
    getAll: "/v1/admin/ConnectedUser/get-all",
    getAllSearch: "/v1/admin/ConnectedUser/get-all-search",
  },
  //Notification
  notification: {
    getAll: "/v1/admin/Notification/get-all",
    getAllSearch: "/v1/admin/Notification/get-all-search",
    getDetail: "/v1/admin/Notification/get-detail",
    edit: "/v1/admin/Notification/edit",
    create: "/v1/admin/Notification/create",
    update: "/v1/admin/Notification/update",
  },
  //Security
  security: {
    getAuthFailures: "/v1/admin/security/auth-failures",
  },
  //Booking
  booking: {
    getAll: "/v1/admin/Booking/get-all",
    getAllSearch: "/v1/admin/Booking/get-all-search",
    updateStatus: "/v1/admin/Booking",
    create: "/v1/admin/Booking",
    edit: "/v1/admin/Booking/edit",
    update: "/v1/admin/Booking",
    getDetail: "/v1/admin/Booking",
  },
  //Bank
  bank: {
    dropdown: "/v1/admin/bank/dropdown",
  },
   //Transaction
  transaction: {
    getAll: "/v1/admin/transaction/get-all",
    getAllSearch: "/v1/admin/transaction/get-all-search",
  },
  //Payment Method
  paymentMethod: {
    getAll: "/v1/admin/PaymentMethods",
    create: "/v1/admin/PaymentMethods",
    update: "/v1/admin/PaymentMethods",
    toggle: "/v1/admin/PaymentMethods",
    delete: "/v1/admin/PaymentMethods",
  },
   //chat (old, kept for later reference)
  chat: {
    getConversations: "/v1/admin/chat/get-conversations",
    getMessages: "/v1/admin/chat/get-messages",
    readMessages: "/v1/admin/chat/read-messages",
    sendMessage: "/v1/admin/chat",
  },
  //Chat (Firebase) - read-only admin chat viewer
  chatFirebase: {
    getConversations: "/v1/admin/ChatFirebase/conversations",
  },
  // Add more endpoints as needed
};
